import firebase from 'firebase/compat/app'
import {
    getDocument,
    saveDocument,
} from './abm'

const collection = 'topics'

export const getTopic = token => getDocument(token, collection)

export const saveTopic = data => firebase.app().firestore().collection(collection).doc(data.id).set({ ...data })
    .then(docRef => Promise.resolve())
    .catch(error => Promise.reject())

export const registerClientTopic = async (data) => { // data has id (user.uid), topic (target topic string), etc.
    try {
        const token = await firebase.messaging().getToken();
        if (token) {
            await saveTopic({
                ...data, // Should include id (user.uid), topic (the string name of the topic to subscribe to)
                token,   // The FCM device token
            });
            console.log(`Successfully prepared topic registration for user ${data.id} to topic ${data.topic} with token ${token}`);
        } else {
            console.error('No FCM token available for registerClientTopic');
            throw new Error('No FCM token available');
        }
    } catch (error) {
        console.error('Error in registerClientTopic:', error);
        // Re-throw or handle as appropriate for the calling context
        throw error;
    }
};

export const updateUserToken = (userId, newToken) => {
    const docRef = firebase.app().firestore().collection('topics').doc(userId);
    return docRef.get().then((doc) => {
        if (doc.exists) {
            return docRef.update({ token: newToken });
        } else {
            // Document does not exist, log an error or create a new one
            // For now, just logging an error as per instructions to prioritize updates
            console.error(`No document found for userId: ${userId} to update token.`);
            // Optionally, create the document:
            // return docRef.set({ token: newToken, userId: userId, /* other default fields */ });
            return Promise.reject('User document not found for token update.');
        }
    }).catch(error => {
        console.error("Error updating user token:", error);
        return Promise.reject(error);
    });
};
